import isEqual from "lodash/isEqual";
import isFunction from "lodash/isFunction";
import pickBy from "lodash/pickBy";

const ReactExt = {
  checkPropsForReRender,
};

function checkPropsForReRender(prevProps, nextProps) {
  const prevPropsToCheck = pickBy(prevProps, (prop) => !isFunction(prop));
  const nextPropsToCheck = pickBy(nextProps, (prop) => !isFunction(prop));

  return isEqual(prevPropsToCheck, nextPropsToCheck);
}

export default ReactExt;
